export default function ResetPasswordRequestForm() {
    return {
        restrict: "E",
        template: require("./template.html"),

        controller: function ($scope, Users) {
            $scope.debug = false; //ENV.debug;

            $scope.doesNotExist = false;

            $scope.user = {};

            $scope.resetPasswordRequest = (email, form) => {
                /**
                 * Any form validation errors ?
                 */
                if (!Object.keys(form.$error).length) {
                    Users.resetPasswordRequest(email).then(
                        () => {
                            $scope.showConfirmation = true;
                            $scope.doesNotExist = false;
                        },
                        () => {
                            $scope.doesNotExist = true;
                        }
                    );
                } else {
                    // console.log("not allowed");
                }
            };
        },
    };
}
